import { Component } from '@angular/core';

@Component({
  selector: 'app-request-features',
  imports: [],
  templateUrl: './request-features.component.html',
  styleUrl: './request-features.component.css',
})
export class RequestFeaturesComponent {

}
